import { PayloadAction } from '@reduxjs/toolkit';
import { ImageHandlingState } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';
import { getImageContextKey } from '@v2/components/imageHandling/helpers';
import { ImageContext } from '@v2/components/imageHandling/types/types';

interface RemoveImageDocumentFromSpecificContextPayload {
  documentId: number;
  imageContext: ImageContext;
}

export const removeImageDocumentFromSpecificContextAction = (
  state: ImageHandlingState,
  action: PayloadAction<RemoveImageDocumentFromSpecificContextPayload>
) => {
  const { documentId, imageContext } = action.payload;
  const key = getImageContextKey(imageContext);
  const contextStore = state.imagesDocumentsContexts[key];

  if (!contextStore) return;

  // Remove document ID from only the specific context
  state.imagesDocumentsContexts[key].documentIds = state.imagesDocumentsContexts[key].documentIds.filter((id) => id !== documentId);

  // Check if document is still referenced in any other context
  const isReferencedElsewhere = Object.values(state.imagesDocumentsContexts).some((context) => context.documentIds.includes(documentId));

  // If not referenced anywhere else, remove from dictionary
  if (!isReferencedElsewhere) {
    delete state.imagesDocumentsDict[documentId];
  }
};
